export const environment = {
  production: false,  // Set to false unless you want it to behave like production
  apiBaseUrl: 'https://au.dev.backend.pulseright.io',
  // Country (ISO) used before a tenant is known: login, OTP, kiosk start. A tenant's
  // own organisation-group country always wins once it's loaded.
  defaultCountry: 'AU',
  socketUrl: 'https://prod.socket.pulseright.io',
  loggingEnabled: false, // Disable verbose logging in staging
  featureFlagX: true,     // Enable or disable features
};
